export default __webpack_public_path__ + "static/media/ingles press.34185288.png";